"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCreditorsRequestSchema = void 0;
const zod_1 = require("zod");
const user_1 = require("../user");
const dateLike = zod_1.z.union([zod_1.z.number(), zod_1.z.string(), zod_1.z.date()]);
exports.GetCreditorsRequestSchema = zod_1.z.object({
    active: zod_1.z
        .string()
        .transform(value => (0, user_1.stringAsBool)(value))
        .pipe(zod_1.z.boolean())
        .nullish(),
    closure_date: dateLike.pipe(zod_1.z.coerce.date()).nullish(),
});
